import Vue from 'vue'
import App from './App'
import Referral from './Referral'
import Router from 'vue-router'
import NProgress from 'nprogress'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
// import InputColorPicker from 'vue-native-color-picker'

import createApp from '@shopify/app-bridge'

import authenticationMixin from '@/mixins/authentication'
import vendorconsignmentRoutes from '@/apps/vendorconsignment/routes'
import vendorconsignmentPortalRoutes
  from '@/apps/vendorconsignment/portalRoutes'
import autoskuRoutes from '@/apps/autosku/routes'
import questionnaireRoutes from '@/apps/questionnaire/routes'
import salesrepsRoutes from '@/apps/salesreps/routes'

import client from '@/mixins/client'
import store from '@/store'
import env from '@/mixins/env'
import {APP, API_KEY} from '@/localSettings'

import '../node_modules/nprogress/nprogress.css'
import '@/styles/app.scss'

Vue.use(Router, VueAxios, axios, VueCookies)

Vue.prototype.window = window
Vue.prototype.axios = axios
Vue.prototype.cookies = VueCookies

let routes = []

if (APP === 'consignment') {
  routes = vendorconsignmentRoutes
} else if (APP === 'consignment-portal') {
  routes = vendorconsignmentPortalRoutes
} else if (APP === 'autosku') {
  routes = autoskuRoutes
} else if (APP === 'questionnaire') {
  routes = questionnaireRoutes
} else if (APP === 'salesreps') {
  routes = salesrepsRoutes
}

// const globalRoutes = [
//   {
//     path: '/login',
//     name: 'login',
//     component: Login
//   }
// ]
//
// routes = routes.concat(globalRoutes)

let router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

Vue.config.productionTip = false

NProgress.configure({
  showSpinner: false
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }

  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

let urlParams = new URLSearchParams(location.search).get('host', false)
if (urlParams) {
  const config = {
    apiKey: API_KEY,
    host: new URLSearchParams(location.search).get('host'),
    forceRedirect: false
  }
  const shopifyApp = createApp(config)
}

/* eslint-disable no-new */
new Vue({
  el: '#site',
  store,
  router,
  mixins: [client, authenticationMixin],
  components: {App, Referral},
  template: '<div><App v-if="canLoad"/><Referral v-if="referral"/></div>',
  // methods: {
  //   async update (response) {
  //     this.$store.state.token = {
  //       'token': response.access,
  //       'expire': expireTime
  //     }
  //
  //     this.$store.state.refreshToken = response.refresh
  //   }
  // },
  data: function () {
    return {
      referral: false
    }
  },
  computed: {
    canLoad () {
      if (this.$route.name !== 'download' && APP !== 'consignment-portal') {
        if (this.$store.state.shop != null && this.$store.state.settings != null && this.$store.state.metas != null) {
          return true
        }
      } else if (APP === 'consignment-portal') {
        if (this.$store.state.portalSettings !== null) {
          if (this.$route.name !== 'vendorPortalLogin' && this.$route.name !== 'vendorPortalPasswordReset') {
            if (this.$store.state.token !== null && this.$store.state.vendors !== null && this.$store.state.metas != null) {
              return true
            }
          } else {
            return true
          }
        }
      }

      return false
    }
  },
  beforeMount () {
    if (this.$route.name !== 'download' && APP !== 'consignment-portal') {
      authenticationMixin.methods.getTokens().then(response => {
        if (!response) {
          // console.log(response)
          // this.referral = true
          document.location.href = env.api_root() + '/?' + env.params()
        } else {
          let expireTime = new Date()

          expireTime.setMinutes(expireTime.getMinutes() + 5)

          this.$store.state.token = {
            'token': response.access,
            'expire': expireTime
          }

          this.$store.state.refreshToken = response.refresh

          axios({
            method: 'post',
            url: env.api_url() + '/token/refresh/',
            data: {
              refresh: this.$store.state.refreshToken
            }
          }).then((response) => {
            if (response.status === 200) {
              this.$store.dispatch('loadSettings')
              let expireTime = new Date()

              expireTime.setMinutes(expireTime.getMinutes() + 5)

              this.$store.state.token = {
                'token': response.data.access,
                'expire': expireTime
              }
            }
          }).catch((error) => {
            if (error) {
              document.location.href = env.api_root() + '/?' + env.params()
            }
          })
        }
      })
    } else if (APP === 'consignment-portal') {
      this.$store.dispatch('loadShop')

      let cookieToken = window.$cookies.get('va-token')
      let cookieRefresh = window.$cookies.get('va-refresh-token')

      if (cookieToken && cookieRefresh) {
        this.$store.state.token = cookieToken
        this.$store.state.refreshToken = cookieRefresh

        axios({
          method: 'post',
          url: env.api_url() + '/token/refresh/',
          data: {
            refresh: cookieRefresh
          }
        }).then((response) => {
          if (response.status === 200) {
            let expireTime = new Date()

            expireTime.setMinutes(expireTime.getMinutes() + 5)

            this.$store.state.token = {
              'token': response.data.access,
              'expire': expireTime
            }

            window.$cookies.set('va-token', this.$store.state.token)

            if (response.data.refresh) {
              this.$store.state.refreshToken = response.data.refresh
              window.$cookies.set('va-refresh-token', this.$store.state.refreshToken)
            }

            this.$store.dispatch('loadVendor')

            if (this.$route.name === 'vendorPortalLogin') {
              this.$router.push('/apps/vendor-portal')
            }
          }
        }).catch(() => {
          window.$cookies.remove('va-token')
          window.$cookies.remove('va-refresh-token')
          if (this.$route.name !== 'vendorPortalLogin' && this.$route.name !== 'vendorPortalPasswordReset') {
            this.$router.push('/apps/vendor-portal/login')
          }
        })
      } else {
        authenticationMixin.methods.getTokens(true).then(response => {
          if (!response && this.$route.name !== 'vendorPortalLogin' && this.$route.name !== 'vendorPortalPasswordReset') {
            this.$router.push('/apps/vendor-portal/login')
          } else if (response) {
            let expireTime = new Date()

            expireTime.setMinutes(expireTime.getMinutes() + 5)

            this.$store.state.token = {
              'token': response.access,
              'expire': expireTime
            }

            this.$store.state.refreshToken = response.refresh

            window.$cookies.set('va-token', this.$store.state.token)
            window.$cookies.set('va-refresh-token', this.$store.state.refreshToken)

            axios({
              method: 'post',
              url: env.api_url() + '/token/refresh/',
              data: {
                refresh: this.$store.state.refreshToken
              }
            }).then((response) => {
              if (response.status === 200) {
                this.$store.dispatch('loadVendor')
                let expireTime = new Date()

                expireTime.setMinutes(expireTime.getMinutes() + 5)

                this.$store.state.token = {
                  'token': response.data.access,
                  'expire': expireTime
                }

                window.$cookies.set('va-token', this.$store.state.token)

                if (this.$route.name === 'vendorPortalLogin') {
                  this.$router.push('/apps/vendor-portal')
                }
              }
            })
          }
        }).catch((error) => {
          if (error && this.$route.name !== 'vendorPortalLogin') {
            this.$router.push('/apps/vendor-portal/login')
          }
        })
      }
    } else {
      let currentURL = (document.URL)
      let parts = currentURL.split('download/?')
      let response = parts[1]
      // let downloadLink = document.createElement('a')
      //
      // if (!response.match(/^data:text\/csv/i)) {
      //   response = 'data:text/csv;charset=utf-8,' + decodeURI(response)
      // }
      //
      // let data = encodeURI(response)
      //
      // downloadLink.href = data
      // downloadLink.download = 'data.csv'
      //
      // document.body.appendChild(downloadLink)
      // downloadLink.click()
      // document.body.removeChild(downloadLink)

      let downloadLink = document.createElement('a')
      let blob = new Blob(['\ufeff', decodeURI(response)])
      let url = URL.createObjectURL(blob)
      downloadLink.href = url
      downloadLink.download = 'data.csv'

      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)

      setTimeout(function () {
        window.open('', '_self').close()
      }, 1000)
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/main.js